import React, { Component } from "react";
import { Col, Form, Input, Row, Typography } from "antd";
import PropTypes from "prop-types";
import { withApollo } from "react-apollo";

class WelfareListPaymentVictimInPersonnelInformation extends Component {
  render() {
    const { rawData, form } = this.props;

    return (
      <Row gutter={16} type="flex" justify="start" align="top" className="py-2">
        <Col md={24} className="mb-3">
          <Typography.Text className="color-red" style={{ fontSize: "18px" }}>
            ข้อมูลบุคลากร
          </Typography.Text>
        </Col>
        <Col md={12} className="mb-2">
          <Form.Item label={"ชื่อบุคลากร"} className="mb-0">
            {form.getFieldDecorator("empFullName", {
              initialValue: rawData?.empFullName || "-",
            })(<Input className="w-100" disabled={true} />)}
          </Form.Item>
        </Col>
        <Col md={12} className="mb-2">
          <Form.Item label={"ตำแหน่ง"} className="mb-0">
            {form.getFieldDecorator("field", {
              initialValue: rawData?.field || "-",
            })(<Input className="w-100" disabled={true} />)}
          </Form.Item>
        </Col>
        <Col md={12} className="mb-2">
          <Form.Item label={"ประเภทบุคลากร"} className="mb-0">
            {form.getFieldDecorator("empType", {
              initialValue: rawData?.empType || "-",
            })(<Input className="w-100" disabled={true} />)}
          </Form.Item>
        </Col>
        <Col md={12} className="mb-2">
          <Form.Item label={"ระดับ"} className="mb-0">
            {form.getFieldDecorator("field", {
              initialValue: rawData?.field || "-",
            })(<Input className="w-100" disabled={true} />)}
          </Form.Item>
        </Col>
        <Col md={12} className="mb-2">
          <Form.Item label={"สำนัก"} className="mb-0">
            {form.getFieldDecorator("orgName", {
              initialValue: rawData?.orgName || "-",
            })(<Input className="w-100" disabled={true} />)}
          </Form.Item>
        </Col>
        <Col md={12} className="mb-2">
          <Form.Item label={"หน่วยงาน"} className="mb-0">
            {form.getFieldDecorator("deptName", {
              initialValue: rawData?.deptName || "-",
            })(<Input className="w-100" disabled={true} />)}
          </Form.Item>
        </Col>
        <Col md={12} className="mb-2">
          <Form.Item label={"ฝ่าย"} className="mb-0">
            {form.getFieldDecorator("diviName", {
              initialValue: rawData?.diviName || "-",
            })(<Input className="w-100" disabled={true} />)}
          </Form.Item>
        </Col>
      </Row>
    );
  }
}

WelfareListPaymentVictimInPersonnelInformation.defaultProps = {
  autoFocus: false,
};

WelfareListPaymentVictimInPersonnelInformation.propTypes = {
  afterSubmit: PropTypes.func,
  forgotLink: PropTypes.string,
  autoFocus: PropTypes.bool,
};

const WrappedWelfareListPaymentVictimInPersonnelInformation = Form.create()(
  WelfareListPaymentVictimInPersonnelInformation
);

export default withApollo(
  WrappedWelfareListPaymentVictimInPersonnelInformation
);
